<script>
  import { onMount, onDestroy } from 'svelte';
  import { reorderPlan } from '@lib/api/plan';

  export let plans = []; // 부모로부터 전달받은 플랜 목록
  export let onClose = () => {};
  export let onSave = () => {};

  
  let reorderPlans = [];    //배열 복사본 생성
  let warningMessage = '';  // 공통 경고 메시지

  // 저장 처리 함수
  async function handleSubmit() {
    // 유효성 검사 시작

    // 1. 유효성 검사 시작
    const orders = reorderPlans.map(plan => Number(plan.order));

    // 숫자 아닌 항목이 있는지 검사
    const hasInvalidNumber = orders.some(order => isNaN(order) || order <= 0);
    if (hasInvalidNumber) {
      warningMessage = '모든 순서 값은 1 이상의 숫자여야 합니다.';
      return;
    }

    // 중복된 숫자가 있는지 검사
    const hasDuplicate = new Set(orders).size !== orders.length;
    if (hasDuplicate) {
      warningMessage = '노출 순서에 중복된 숫자가 있습니다.';
      return;
    }

    // 2. 유효성 통과 시
    warningMessage = ''; // 경고 초기화
    try {

      const payload = reorderPlans.map(plan => ({
        plan_id: plan._id,
        order: Number(plan.order)  // 숫자 보장
      }));
      const result = await reorderPlan(payload); // 플랜 순서 변경 API 호출
      console.log('수정 성공:', result);
      onSave(); // 수정 완료 후 콜백 호출
    } catch (e) {
      console.error('저장 실패:', e);
      warningMessage = e.message || '저장 중 오류가 발생했습니다.';
    }
  }

  /**
   * 드롭다운 외부 클릭 시 드롭다운을 닫기 위한 이벤트 핸들러
   * @param {{ target: any; }} event 클릭 이벤트 객체
   */
  function handleClickOutside(event) {
  }


  onMount(() => {
    reorderPlans = plans.map(p => ({ ...p }));
  });

  onDestroy(() => {
    reorderPlans = [];
  });
</script>
<div class="popup-wrap" id="popup-plan-order">
  <div class="popup-overlay" role="presentation" aria-label="팝업 닫기" on:click={onClose}></div>
  <section class="popup-container">
      <div class="popup-container__inner d-flex" style="max-width:65.2rem;">
          <div class="d-flex flex-column w-100">
              <div class="popup-header">
                  <div class="d-flex align-center w-100">
                      <p class="font-20 font-weight-700 line-height-2">
                          플랜 노출 순서 변경하기
                      </p>
                      <button type="button" class="btn-close ml-auto"  aria-label="닫기" on:click={onClose}>
                          <i class="icon icon-close"></i>
                      </button>
                  </div>
              </div>
              <div class="popup-cont">
                  <div class="d-flex h-100">
                      <div class="prompt-block">
                          <div class="table-wrap mt-2 flex-1">
                              <table class="table-basic table-border table-basic-playApply2">
                                  <caption>노출 순서 변경 테이블</caption>
                                  <colgroup>
                                      <col style="width:15%">
                                      <col style="width:auto">
                                      <col style="width:15%">
                                      <col style="width:35%">
                                  </colgroup>
                                  <thead>
                                  <tr>
                                      <th scope="col">노출 순서</th>
                                      <th scope="col">플랜명</th>
                                      <th scope="col">금액</th>
                                      <th scope="col">단위</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                    {#each reorderPlans as plan, i (plan._id)}
                                      <tr>
                                        <td>
                                          <form action="" class="d-flex align-center flex-wrap">
                                            <fieldset class="w-100">
                                              <legend>플랜 노출순서 input 텍스트</legend>
                                              <label for={`input-field-order-${i}`}>
                                                <input
                                                  type="text"
                                                  id={`input-field-order-${i}`}
                                                  class="input-field h-40"
                                                  title="플랜 노출순서 input 텍스트"
                                                  bind:value={plan.order}
                                                />
                                              </label>
                                            </fieldset>
                                          </form>
                                        </td>
                                        <td>{plan.plan_name}</td>
                                        <td>{plan.amount.toLocaleString()}</td>
                                        <td>{plan.unit || '원 / 월'}</td>
                                      </tr>
                                    {/each}
                                  </tbody>
                              </table>
                          </div>
                          {#if warningMessage}
                            <p class="d-flex align-center mt-3 font-13 color-red">
                              <i class="icon icon-calmMark-red mr-1"></i>
                              {warningMessage}
                            </p>
                          {/if}
                      </div>
                  </div>
              </div>
              <div class="popup-footer">
                  <div class="btn-wrap justify-center" style="border-top:none;">
                      <button type="button" class="btn border-blue" on:click={onClose}>취소</button>
                      <button type="button" class="btn bg-blue ml-2" on:click={handleSubmit}>저장하기</button>
                  </div>
              </div>
          </div>
      </div>
  </section>
</div>